import type {
  LiveTrackerSound,
  LiveActivityEvent,
  LiveActivityOverview,
  AbandonedCartsFilters,
  AbandonedCartsResponse,
} from 'src/types/live-activity';

import axios from 'src/lib/axios';

export const liveActivityApi = {
  getOverview: (params?: {
    onlineWindowSeconds?: number;
    eventsMinutes?: number;
    eventsLimit?: number;
  }): Promise<{ data: LiveActivityOverview }> =>
    axios.get('/api/admin/LiveActivityAdmin/overview', { params }),

  getUserTimeline: (userId: number, minutes = 60): Promise<{ data: LiveActivityEvent[] }> =>
    axios.get(`/api/admin/LiveActivityAdmin/user/${userId}/timeline`, { params: { minutes } }),

  // --- Sonidos de aviso (pedido / recarga de saldo) ---

  getSounds: (): Promise<{ data: LiveTrackerSound[] }> =>
    axios.get('/api/admin/LiveActivityAdmin/sounds'),

  uploadSound: (
    kind: string,
    payload: { fileName: string; fileBase64: string }
  ): Promise<{ data: LiveTrackerSound }> =>
    axios.post(`/api/admin/LiveActivityAdmin/sounds/${kind}`, payload),

  deleteSound: (kind: string): Promise<unknown> =>
    axios.delete(`/api/admin/LiveActivityAdmin/sounds/${kind}`),

  /** Descarga el fichero (va autenticado, por eso no se puede poner la URL en un <audio src>). */
  getSoundFile: (kind: string): Promise<{ data: Blob }> =>
    axios.get(`/api/admin/LiveActivityAdmin/sounds/${kind}/file`, { responseType: 'blob' }),

  // --- Carritos abandonados ---

  getAbandonedCarts: (params: AbandonedCartsFilters): Promise<{ data: AbandonedCartsResponse }> =>
    axios.get('/api/admin/LiveActivityAdmin/abandoned-carts', { params }),

  markCartContacted: (userId: number, note?: string): Promise<unknown> =>
    axios.post(`/api/admin/LiveActivityAdmin/abandoned-carts/${userId}/contacted`, { note }),

  unmarkCartContacted: (userId: number): Promise<unknown> =>
    axios.delete(`/api/admin/LiveActivityAdmin/abandoned-carts/${userId}/contacted`),
};
